import type { CopyShape } from "../../intl";

import type { ERRORS_COPY_PT_BR } from "../errors.copy";

export const ERRORS_COPY_ES_ES: CopyShape<typeof ERRORS_COPY_PT_BR> = {
  network: "No hemos podido conectar con el servidor. Revisa tu conexión.",
  unauthorized: "Tu sesión ha caducado. Vuelve a iniciar sesión.",
  forbidden: "No tienes acceso a este recurso.",
  unexpectedResponse: (endpoint: string) => `Respuesta inesperada del servidor en ${endpoint}.`,
  generic: "Algo ha fallado. Vuelve a intentarlo.",
  passwordChangeRequired: "Cambia tu contraseña para continuar.",
  legalAcceptanceRequired: "Acepta los Términos de Uso actualizados para continuar.",
  demoMode: "Esto es solo un ejemplo: no se ha guardado nada.",
  phoneNotVerified:
    "Confirma tu teléfono antes de pedir la propuesta: es por ahí por donde te avisamos cuando esté lista.",
};
